import { render, staticRenderFns } from "./IssueContent.vue?vue&type=template&id=0f151fe4&scoped=true&"
import script from "./IssueContent.vue?vue&type=script&lang=js&"
export * from "./IssueContent.vue?vue&type=script&lang=js&"
import style0 from "./IssueContent.vue?vue&type=style&index=0&id=0f151fe4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f151fe4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
